import { ERROR_TEST_PAGE_ENABLED } from '@/constant';
import ErrorFallback from '@/errorHandling/page/ErrorFallback';
import { Navigate, createFileRoute } from '@tanstack/react-router';
import type { ErrorInfo } from 'react';
import { ErrorBoundary, useErrorBoundary } from 'react-error-boundary';

export const Route = createFileRoute('/error-test/')({
  component: component,
});

function component() {
  const { showBoundary } = useErrorBoundary();

  if (ERROR_TEST_PAGE_ENABLED !== 'true') {
    return <Navigate to="/" />;
  }

  const onError = (error: Error, info: ErrorInfo) => {
    console.log('======= ErrorBoundary onError');
    console.log(error);
    console.log(info);
  };

  return (
    <ErrorBoundary
      FallbackComponent={() => <ErrorFallback type="normal" />}
      onError={onError}
    >
      <h1>Error Test用ページ</h1>
      <button
        onClick={() => {
          showBoundary(new Error('Error from Error Test Viewaaaaaa.'));
        }}
        type="button"
        style={{ border: '1px solid black', padding: '5px' }}
      >
        エラー発生ボタン
      </button>
    </ErrorBoundary>
  );
}
